export default function About() {
  return (
    <section className="relative bg-[#F8F9FB] py-[180px] overflow-hidden">
      {/* Decorative circle */}
      <div 
        className="absolute top-1/2 left-[70%] w-[600px] h-[600px] rounded-full bg-purple-200/30 blur-3xl -translate-y-1/2"
      ></div>

      <div className="relative z-10 px-[120px]">
        <h2 className="text-5xl font-bold text-[#1C1C1E] mb-24" style={{ marginLeft: '15%' }}>
          About FERAR SH.P.K.
        </h2>

        <div 
          className="bg-white rounded-[32px] p-[60px] shadow-lg max-w-[850px]"
          style={{ marginLeft: '25%' }}
        >
          <div className="grid grid-cols-3 gap-10">
            <div>
              <p className="text-base leading-7 text-[#6B6B6B]">
                FERAR SH.P.K. is a dedicated team of iOS development experts committed to creating innovative mobile applications that transform user experiences.
              </p>
            </div>
            <div>
              <p className="text-base leading-7 text-[#6B6B6B]">
                Our focus on security and performance ensures that every application we develop meets the highest standards of quality and reliability for iOS users worldwide.
              </p>
            </div>
            <div>
              <p className="text-base leading-7 text-[#6B6B6B]">
                With years of experience in mobile app development, we specialize in VPN solutions and device optimization tools that enhance privacy and device performance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}